import React from "react";
import { useState, useEffect, useCallback } from "react";
import { getCampaignFilter } from "../../services/campaign";

const useAdsFilterPanel = () => {
  const [apiData, setApiData] = useState({
    ads_type: [],
    match_type: [],
    brands: [],
    campaign_status: [],
  });

  const [loading, setLoading] = useState(true);

  const getFilters = useCallback(async () => {
    try {
      setLoading(true);
      const res = await getCampaignFilter();

      if (res?.success) {
        setApiData(res.data);
      }
    } catch (err) {
      console.error("Error fetching filters:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    getFilters();
  }, [getFilters]);

  return {
    loading,
    apiData,
    refetch: getFilters, // useful if you want manual refresh
  };
};

export default useAdsFilterPanel;